export default __webpack_public_path__ + "static/media/offer-vertical-chocolate@3x.d814dcac.png";